import { render, staticRenderFns } from "./GantTravel.vue?vue&type=template&id=d9c36934&scoped=true&"
var script = {}
import style0 from "./GantTravel.vue?vue&type=style&index=0&id=d9c36934&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9c36934",
  null
  
)

export default component.exports